import React, { useEffect, useRef, useState } from "react";
import Input from "../../../comman/input";
import { Modal, Button, Tabs, Tab } from "react-bootstrap";
import TextArea from "../../../comman/textarea";
import { useDispatch, useSelector } from "react-redux";
import {
  addMultipleReqDocuments,
  addReqDocuments,
  documentUploaded,
  getMultipleReqDocAddedStatus,
  getReqDocAddedStatus,
  getUploadDocumentId,
  multipleReqDocumentAdded,
  reqDocumentAdded,
  uploadDocument,
} from "../../store/documents";
import { getAlert, getConfirmAlert } from "../../../services/appAlerts";
import { getCurrentUser } from "../../store/auth";
import UploadRepository from "./UploadRepository";
import {
  ddrmsRepoReqDocUploaded,
  getDdrmsRepoUploadedDocId,
  UploadDdrmsReqRepositoryDocs,
} from "../../store/ddrmsDocument";
import PurchaseOrderPopup from "../../../ReviewTools/PurchaseOrderPopup";

const UploadOther = (props) => {
  const {
    handleOtherDocShowHide,
    otherDocShowHide,
    workflowTask,
    onReqDocs,
    applicantObj,
    uploadType,
    viewType,
  } = props;

  const [docName, setDocName] = useState("");
  const [docNotes, setDocNotes] = useState("");
  const [documents, setDocuments] = useState([]);
  const [btnProcess, setBtnProcess] = useState(null);
  const [selectedRepoDocs, setSelectedRepoDocs] = useState([]);
  const [refDocType, setRefDocType] = useState("");
  const [isDragging, setIsDragging] = useState(false);
  const [selectedDocIds, setSelectedDocIds] = useState([]);
  const [selectedDocName, setSelectedDocName] = useState("");
  const [selectedKey, setSelectedKey] = useState("generate");
  const [poOrderType, setPoOrderType] = useState("add");

  const reqDocAddedStatusSelector = useSelector(getReqDocAddedStatus);
  const multipleReqDocAddedStatusSelector = useSelector(
    getMultipleReqDocAddedStatus
  );
  const uploadDocumentIdSelector = useSelector(getUploadDocumentId);
  const ddrmsRepoUploadedDocIdSelector = useSelector(getDdrmsRepoUploadedDocId);

  const dispatch = useDispatch();
  const currentUser = getCurrentUser();
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (!otherDocShowHide) {
      setDocuments([]);
      setSelectedDocIds([]);
      setDocName("");
      setDocNotes("");
    }
  }, [otherDocShowHide]);

  const handleSubmit = async () => {
    setBtnProcess(true);
    let wfTask = { ...workflowTask };
    wfTask.performerId = parseInt(currentUser.id);
    let usrId = currentUser.id;
    if (viewType === "candidateList") {
      if (uploadType === "Recruiter" && applicantObj?.recruiter?.parentid)
        wfTask.applicantId = applicantObj.recruiter.parentid;
      else if (
        uploadType === "Subcontractor" &&
        applicantObj?.subcontractor?.parentid
      )
        wfTask.applicantId = applicantObj.subcontractor.parentid;
      else if (uploadType === "Candidate" && applicantObj?.id)
        wfTask.applicantId = applicantObj?.id;
    } else if (applicantObj?.id) {
      wfTask.applicantId = applicantObj?.id;
    }
    console.log(wfTask);

    if (documents.length > 0 || selectedRepoDocs.length > 0) {
      let updType = "sharing";
      let isPwd = "";

      var frmData = new FormData();
      frmData.append("workflowTask", JSON.stringify(wfTask));
      frmData.append("userId", currentUser.id);
      frmData.append("docType", "req");
      frmData.append("updType", updType);
      frmData.append("isPwd", isPwd);

      if (refDocType === "local") {
        documents.map((file, key) =>
          frmData.append("files[" + key + "]", file.file)
        );
        const result = await getConfirmAlert(
          "Warning",
          "Are you sure you want to send this Document?",
          "warning"
        );
        if (result.isConfirmed) dispatch(uploadDocument(frmData));
      } else if (refDocType === "ddrms") {
        frmData.append("message", "Required Document");
        const updDocs = selectedRepoDocs.map((doc) => {
          const newDoc = { ...doc };
          newDoc.docType = "req";
          return newDoc;
        });
        frmData.append("doc", JSON.stringify(updDocs));
        const result = await getConfirmAlert(
          "Warning",
          "Are you sure you want to send this Document?",
          "warning"
        );
        if (result.isConfirmed) dispatch(UploadDdrmsReqRepositoryDocs(frmData));
      }
    } else {
      const allReqDocs = [];
      selectedDocIds.forEach((id) => {
        const doc = onReqDocs.find((d) => d.id === id && d.name !== "Other");
        if (doc) {
          const frmObj = {
            formId: 0,
            documnetName: doc.name,
            notes: docNotes,
            ciid: wfTask.ciid,
            iiid: wfTask.iiid,
            wiid: wfTask.wiid,
            performerId: wfTask.applicantId,
            addedBy: currentUser.id,
          };
          allReqDocs.push(frmObj);
        }
      });

      if (selectedDocName === "Other" && docName.trim() !== "") {
        const frmObj = {
          formId: 0,
          documnetName: docName,
          notes: docNotes,
          ciid: wfTask.ciid,
          iiid: wfTask.iiid,
          wiid: wfTask.wiid,
          performerId: wfTask.applicantId,
          addedBy: currentUser.id,
        };
        allReqDocs.push(frmObj);
      }

      dispatch(addMultipleReqDocuments(allReqDocs));
      //dispatch(addReqDocuments(frmObj));
    }
  };

  useEffect(() => {
    if (uploadDocumentIdSelector || ddrmsRepoUploadedDocIdSelector) {
      let wfTask = { ...workflowTask };
      wfTask.performerId = parseInt(currentUser.id);
      let usrId = currentUser.id;
      if (viewType === "candidateList") {
        if (uploadType === "Recruiter" && applicantObj?.recruiter?.parentid)
          wfTask.applicantId = applicantObj.recruiter.parentid;
        else if (
          uploadType === "Subcontractor" &&
          applicantObj?.subcontractor?.parentid
        )
          wfTask.applicantId = applicantObj.subcontractor.parentid;
        else if (uploadType === "Candidate" && applicantObj?.id)
          wfTask.applicantId = applicantObj?.id;
      } else if (applicantObj?.id) {
        wfTask.applicantId = applicantObj?.id;
      }

      let refDocId = uploadDocumentIdSelector;

      if (refDocType === "ddrms" && ddrmsRepoUploadedDocIdSelector) {
        refDocId = ddrmsRepoUploadedDocIdSelector;
      }

      const allReqDocs = [];
      selectedDocIds.forEach((id) => {
        const doc = onReqDocs.find((d) => d.id === id && d.name !== "Other");
        if (doc) {
          const frmObj = {
            formId: 0,
            documnetName: doc.name,
            notes: docNotes,
            ciid: wfTask.ciid,
            iiid: wfTask.iiid,
            wiid: wfTask.wiid,
            performerId: wfTask.applicantId,
            addedBy: currentUser.id,
            refDocId: refDocId,
          };
          allReqDocs.push(frmObj);
        }
      });

      if (selectedDocName === "Other" && docName.trim() !== "") {
        const frmObj = {
          formId: 0,
          documnetName: docName,
          notes: docNotes,
          ciid: wfTask.ciid,
          iiid: wfTask.iiid,
          wiid: wfTask.wiid,
          performerId: wfTask.applicantId,
          addedBy: currentUser.id,
          refDocId: refDocId,
        };
        allReqDocs.push(frmObj);
      }

      dispatch(addMultipleReqDocuments(allReqDocs));
      //dispatch(addReqDocuments(frmObj));
      //dispatch(documentUploaded(null));
      //dispatch(ddrmsRepoReqDocUploaded({status: null, docId: null}));
    }
  }, [uploadDocumentIdSelector, ddrmsRepoUploadedDocIdSelector]);

  useEffect(() => {
    if (reqDocAddedStatusSelector) {
      setBtnProcess(false);
      getAlert("", "Document Uploaded Successfully", "success");
      setDocName("");
      setDocNotes("");
      setDocuments([]);
      handleOtherDocShowHide("save");
      dispatch(documentUploaded(null));
      dispatch(ddrmsRepoReqDocUploaded({ status: null, docId: null }));
      dispatch(reqDocumentAdded(false));
    }
  }, [reqDocAddedStatusSelector]);

  useEffect(() => {
    if (multipleReqDocAddedStatusSelector) {
      setBtnProcess(false);
      getAlert("", "Document(s) Uploaded Successfully", "success");
      setDocName("");
      setDocNotes("");
      setDocuments([]);
      setSelectedDocIds([]);
      handleOtherDocShowHide("save");
      dispatch(documentUploaded(null));
      dispatch(ddrmsRepoReqDocUploaded({ status: null, docId: null }));
      dispatch(multipleReqDocumentAdded(false));
    }
  }, [multipleReqDocAddedStatusSelector]);

  const handleOnChange = (obj) => {
    console.log(obj);
  };

  const handleFileChange = (event) => {
    const docs = [...documents];
    for (const file of event.target.files) {
      var doc = {
        name: file.name,
        type: file.type,
        file: file,
        size: file.size,
      };
      docs.push(doc);
    }
    setDocuments(docs);

    event.target.value = null;
  };

  const handleFileRemove = (item) => {
    const updatedDocuments = documents.filter((doc) => doc !== item);
    setDocuments(updatedDocuments);
  };

  // Drag & Drop Handlers
  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const files = Array.from(e.dataTransfer.files);
    const docs = files.map((file) => ({
      name: file.name,
      type: file.type,
      size: (file.size / 1024).toFixed(2),
      file: file,
    }));
    setDocuments((prev) => [...prev, ...docs]);
  };

  const handleSelectedDocIds = (e) => {
    const { value, checked } = e.target;
    console.log(value, checked);
    if (checked) {
      setSelectedDocIds((prev) => [...prev, parseInt(value)]);
      const doc = onReqDocs.find(
        (d) => d.id === parseInt(value) && d.name === "Other"
      );
      if (doc) setSelectedDocName(doc.name);
    } else {
      setSelectedDocIds((prev) => prev.filter((id) => id !== parseInt(value)));
      const doc1 = onReqDocs.find(
        (d) => d.id === parseInt(value) && d.name === "Other"
      );
      if (doc1) setSelectedDocName("");
    }
  };

  const handleSelectedKey = (key) => {
    setSelectedKey(key);
  };

  const handlePurchaseShowHide = (item, type, poOrderType) => {
    // setSelectedDocId(0);
    // setSelectedDoc(null);
    // setPoOrderType(poOrderType);
    // setPurchaseShowHide(true);
    // if (item) {
    //     setSelectedItem(item);
    // }
  };
  const handleSignUnsignPo = (poOrder) => {
    // Logic to sign or unsign the purchase order
  };
  const handleRefreshPoOrders = () => {
    // Logic to refresh the purchase orders
    //handleModalShowHide("save");
    if (selectedKey !== "poOrder") handleOtherDocShowHide("save");
  };

  return (
    <>
      <Modal show={otherDocShowHide} size="xl">
        <Modal.Header closeButton onHide={handleOtherDocShowHide}>
          <Modal.Title>Upload Required Document - {uploadType}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="border">
          <Tabs
            onSelect={handleSelectedKey}
            activeKey={selectedKey}
            //defaultActiveKey={"generate"}
            id="uncontrolled-tab-example"
            className="h3 border border-right-0 border-left-0 border-top-0 font-weight-normal"
          >
            <Tab
              eventKey="generate"
              title="Required Documents"
              tabClassName="page-tab border border-left-0 border-top-0"
            >
              <Tab.Content className="border p-3 border-top-0">
                <div className="row">
                  <div className="col-md-12 form-group">
                    <label
                      htmlFor="docName"
                      style={{ fontWeight: "600", fontSize: "15px" }}
                    >
                      Document Name
                    </label>
                    {/* <select
                            id="docName"
                            className="form-control"
                            value={docName}
                            onChange={(e) => setDocName(e.target.value)}
                        >
                            <option value="">Select Document</option>
                            {onReqDocs.map((doc) => (
                                <option key={doc.id} value={doc.name}>{doc.name}</option>
                            ))}
                        </select> */}

                    {onReqDocs.map((doc) => (
                      <div
                        key={doc.id}
                        className="custom-control custom-checkbox ml-2"
                      >
                        <input
                          type="checkbox"
                          id={`doc-${doc.id}`}
                          className="custom-control-input"
                          value={doc.id}
                          checked={selectedDocIds.includes(doc.id)}
                          onChange={handleSelectedDocIds}
                        />
                        <label
                          className="custom-control-label"
                          htmlFor={`doc-${doc.id}`}
                        >
                          {doc.name}
                        </label>
                      </div>
                    ))}
                  </div>
                  {selectedDocName === "Other" && (
                    <div className="col-md-12 form-group">
                      <Input
                        name="docName"
                        value={docName}
                        label="Other Document Name"
                        onChange={({ target }) => setDocName(target.value)}
                      />
                    </div>
                  )}

                  <div className="col-md-12 form-group">
                    <TextArea
                      name="docNotes"
                      value={docNotes}
                      label="Document Notes"
                      onChange={({ target }) => setDocNotes(target.value)}
                    />
                  </div>
                  <div className="col-md-12 d-flex form-group">
                    <label htmlFor="refDoc" className="form-control-label mr-2">
                      Upload Reference Document
                    </label>
                    <div className="custom-control custom-radio mr-3">
                      <input
                        className="custom-control-input"
                        type="radio"
                        name="refDocType"
                        id="local"
                        onChange={() => setRefDocType("local")}
                        value="local"
                        checked={refDocType === "local"}
                      />
                      <label className="custom-control-label" htmlFor="local">
                        Upload From Local
                      </label>
                    </div>
                    <div className="custom-control custom-radio mr-3">
                      <input
                        className="custom-control-input"
                        type="radio"
                        name="refDocType"
                        id="ddrms"
                        onChange={() => setRefDocType("ddrms")}
                        value="ddrms"
                        checked={refDocType === "ddrms"}
                      />
                      <label className="custom-control-label" htmlFor="ddrms">
                        Upload From DDRMS Repository
                      </label>
                    </div>
                  </div>
                  {refDocType === "local" && (
                    <div className="col-md-12 form-group">
                      {/* Drop Zone */}
                      <div
                        className={`drop-zone w-100 p-4 mb-3 text-center border rounded ${
                          isDragging ? "bg-light" : ""
                        }`}
                        onDragOver={handleDragOver}
                        onDragLeave={handleDragLeave}
                        onDrop={handleDrop}
                        onClick={() => fileInputRef.current.click()}
                        style={{
                          border: "2px dotted #ccc",
                          borderRadius: "8px",
                          padding: "30px",
                          textAlign: "center",
                          background: isDragging ? "#f0f8ff" : "#fafafa",
                          cursor: "pointer",
                          transition: "background 0.2s ease",
                        }}
                      >
                        <i
                          className="fa fa-cloud-upload fa-2x mb-2"
                          aria-hidden="true"
                        ></i>
                        <p className="mb-0">
                          {isDragging
                            ? "Drop files here..."
                            : "Drag & drop files here, or click to select"}
                        </p>
                      </div>
                      <input
                        type="file"
                        name="refDoc"
                        ref={fileInputRef}
                        id="refDoc"
                        className="form-control"
                        onChange={handleFileChange}
                        style={{ display: "none" }}
                      />

                      {/* File Previews */}
                      {documents.length > 0 && (
                        <div className="file-preview w-100 mb-3">
                          {documents.map((file, index) => (
                            <div
                              key={index}
                              className="file-preview-item d-flex align-items-center"
                            >
                              <span>{file.name}</span>
                              <span
                                className="file-size"
                                style={{
                                  backgroundColor: "#f0f0f0",
                                  marginLeft: "10px",
                                  padding: "2px 5px",
                                  borderRadius: "5px",
                                }}
                              >
                                {file.size} KB
                              </span>
                              <button
                                className="btn btn-sm btn-link"
                                onClick={() => handleFileRemove(file)}
                              >
                                <i
                                  className="fa fa-times text-black"
                                  aria-hidden="true"
                                ></i>
                              </button>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  )}
                  {refDocType === "ddrms" && (
                    <UploadRepository
                      workItem={workflowTask}
                      setSelectedRepoDocs={setSelectedRepoDocs}
                    />
                  )}
                </div>
              </Tab.Content>
            </Tab>
            {viewType === "candidateList" && (
              <Tab
                eventKey="poOrder"
                title="Generate/Upload Purchase Order"
                tabClassName="page-tab border border-left-0 border-right-0 border-top-0"
              >
                <Tab.Content className="border p-3 border-top-0">
                  {selectedKey === "poOrder" && (
                    <PurchaseOrderPopup
                      purchaseShowHide={true}
                      handlePurchaseShowHide={handlePurchaseShowHide}
                      candidateObj={applicantObj}
                      workflowTask={workflowTask}
                      poOrderType={poOrderType}
                      item={{
                        partnerType:
                          uploadType === "Recruiter"
                            ? "Recruiter"
                            : "Sub-Contractors",
                      }}
                      handleSignUnsignPo={handleSignUnsignPo}
                      handleRefreshPoOrders={handleRefreshPoOrders}
                      renderType="generate"
                    ></PurchaseOrderPopup>
                  )}
                </Tab.Content>
              </Tab>
            )}
          </Tabs>
        </Modal.Body>
        <Modal.Footer>
          {/* <button className="btn btn-sm btn-outline-default" onClick={handleOtherDocShowHide}>
                    <i class="fa fa-times"></i> Close
                </button> */}
          <button
            className="btn btn-sm btn-outline-default"
            disabled={btnProcess || selectedDocIds.length === 0}
            onClick={handleSubmit}
          >
            {btnProcess ? (
              <i class="fa fa-circle-o-notch fa-spin"></i>
            ) : (
              <i class="fa fa-check"></i>
            )}{" "}
            Attach
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default UploadOther;
